import { render, staticRenderFns } from "./LoaderComponent.vue?vue&type=template&id=02e73658&"
import script from "./LoaderComponent.vue?vue&type=script&lang=ts&"
export * from "./LoaderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports